import { getLocalStorage } from 'lib/get-local-storage'
import { getSessionStorage } from 'lib/get-session-storage'

export const API_TOKEN_KEY = 'apiToken'
export const ANON_API_TOKEN_KEY = 'anonApiToken'

// Shape only, no signature check: enough to refuse '', 'null', 'undefined',
// whitespace and HTML error pages, which are what has ended up in storage.
const JWT_SHAPE = /^[\w-]+\.[\w-]+\.[\w-]+$/

export const isWellFormedToken = (value: unknown): value is string =>
  typeof value === 'string' && JWT_SHAPE.test(value.trim())

// A stored value that is not a token reads as absent and is removed, so a
// browser poisoned before this shipped heals on its first read.
export const readApiToken = (): string | null => {
  const localStorage = getLocalStorage()
  const raw = localStorage?.getItem(API_TOKEN_KEY)
  if (raw == null) return null
  if (isWellFormedToken(raw)) return raw.trim()
  localStorage?.removeItem(API_TOKEN_KEY)
  return null
}

// Stores a well-formed token and returns true; anything else removes the key
// and returns false, so no caller can blind-write a blank credential.
export const setApiToken = (value: unknown): boolean => {
  const localStorage = getLocalStorage()
  if (!localStorage) return false
  if (isWellFormedToken(value)) {
    localStorage.setItem(API_TOKEN_KEY, value.trim())
    return true
  }
  localStorage.removeItem(API_TOKEN_KEY)
  return false
}

// The logged-in user's token only; the anonymous report token is a separate
// credential.
export const clearUserToken = (): void => {
  getLocalStorage()?.removeItem(API_TOKEN_KEY)
}

export const clearAuthTokens = (): void => {
  clearUserToken()
  getSessionStorage()?.removeItem(ANON_API_TOKEN_KEY)
}
